import { useNavigate, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

const PaymentFailure = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isUpdating, setIsUpdating] = useState(true);

  useEffect(() => {
    const updateBookingStatus = async () => {
      const cartId = searchParams.get('cartId') || searchParams.get('id') || searchParams.get('token');
      
      if (cartId) {
        try {
          // Call edge function to update status securely
          const { error } = await supabase.functions.invoke('update-payment-status', {
            body: { paymentId: cartId, status: 'failed' }
          });

          if (error) {
            console.error('Error updating booking:', error);
          }
        } catch (error) {
          console.error('Error updating booking status:', error);
        }
      }
      setIsUpdating(false);
    };

    updateBookingStatus();
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-secondary/20 p-4">
      <div className="bg-card rounded-lg shadow-2xl p-8 max-w-md w-full text-center">
        <div className="mb-6 flex justify-center">
          <XCircle className="w-20 h-20 text-destructive" />
        </div>
        
        <h1 className="text-3xl font-bold mb-4 text-foreground">Payment Failed</h1>
        
        <p className="text-muted-foreground mb-8">
          We couldn't process your payment. Please try again or contact support if the problem persists.
        </p>

        <div className="space-y-3">
          <Button
            onClick={() => navigate("/")}
            className="w-full bg-primary hover:bg-primary/90"
          >
            Try Again
          </Button>
          
          <Button
            onClick={() => navigate("/")}
            variant="outline"
            className="w-full"
          >
            Return to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;
